class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
    }
    if (this.summaryToggle) {
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
      this.summaryToggle.setAttribute('role', 'button');
    }
    const button = this.querySelector('button[type="button"]');
    if (button) {
      button.addEventListener('click', this.close.bind(this));
    }
    const resetBtn = this.querySelector('button[type="reset"]');
    if (resetBtn) {
      resetBtn.addEventListener('click', this.reset.bind(this));
    }
  }

  onSummaryClick(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    const details = event && event.target && typeof event.target.closest === 'function' ? event.target.closest('details') : this.detailsContainer;
    if (details) {
      details.hasAttribute('open') ? this.close() : this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    if (this.detailsContainer) {
      this.detailsContainer.setAttribute('open', true);
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');
  }

  close() {
    removeTrapFocus();
    if (this.detailsContainer) this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    const searchInput = this.querySelector('input[type="search"]');
    if (searchInput) searchInput.value = '';
  }
}

customElements.define('search-modal', SearchModal);
